/**
 * append Dropdowns to body on show
 *
 */
$(document).on('shown.bs.dropdown', '.table-responsive .dropdown, .table-responsive .dropup',function (e) {
    var $dropdown = $(this);
    var $target = $(e.target);
    $target = $target.find('.dropdown-menu');
    if($target.length !== 0) {
        var left = $target.offset().left;
        var width = $target.width();
        var right = left + width;
        right = width - right;
        var top = $target.offset().top;
        var style = $target.attr('style');

        $target.detach();
        $target.css({
            display: 'block',
            position: 'absolute',
            width: width,
            left: left,
            top: top,
            right: right,
        });
        $target[0].style.cssText += ';bottom: auto !important;';
        $('body').append($target);

        $target.on('touchend', function () {
            $target.trigger('hide.bs.dropdown')
        });

        $(document).on('hide.bs.dropdown', function () {
            $dropdown.removeClass('open');
            $target.removeAttr('style');
            $target.attr('style', style);
            $dropdown.append($target);
        });
    }
});
